import { Injectable } from '@angular/core';
import { CommonDataService } from '@sb-tools/typescript/services/common-data.service';
import { WindowRef } from '@sb-tools/typescript/services/window-ref.service';

@Injectable({
    providedIn: 'root',
})
export class OpenTicketInNewWindowService {
    private ticketWindows = new Map<number, Window>();

    constructor(
        private commonDataService: CommonDataService,
        private windowRef: WindowRef,
    ) {}

    openTicketInNewTab(ticketId: number): void {
        window.open(
            window.location.origin + '/' + this.commonDataService.communityName + '/tickets?ticketId=' + ticketId,
            '_blank',
        );
    }

    openTicketInNewWindow(ticketId: number, replyId?: number): void {
        const singleTicketLink =
            this.windowRef.nativeWindow.location.origin +
            '/' +
            this.commonDataService.communityName +
            '/ticket?ticketId=' +
            ticketId +
            (replyId ? '&replyId=' + replyId : '');
        const windowWidth = 1000;
        const right = 100;
        const left = window.screen.width - windowWidth - right;
        const windowFeatures = `popup,left=${left},top=100,width=1000,height=800`;
        const ticketWindow = window.open(singleTicketLink, `Ticket${ticketId}`, windowFeatures);
        if (ticketWindow) {
            this.ticketWindows.set(ticketId, ticketWindow);
        }
    }

    closeTicketWindow(ticketId: number): void {
        const ticketWindow = this.ticketWindows.get(ticketId);
        if (ticketWindow && !ticketWindow.closed) {
            ticketWindow.close();
        }
        this.ticketWindows.delete(ticketId);
    }
}
